module.exports = __webpack_public_path__ + "img/digitable-platforme-old.65c88be8.png";